module.exports = "/images/file-odt-icon.svg?f929562a1168c7251a5a57c6d84fd268";